import{styled}from'styled-components';export const Container=styled.div.withConfig({componentId:"sc-yjij8v-0"})(["grid-column:auto / span 6;"]);